// ── EasterEggGame.js — 업종별 미니게임 라우터 ─────────────────
// mode prop으로 적합한 게임 컴포넌트 선택. 각 게임은 자기 캔버스·스코어 관리.

import React from 'react';
import FlappyFood from './games/FlappyFood';
import HaircutBeauty from './games/HaircutBeauty';
import PaintInterior from './games/PaintInterior';
import CarRunnerAuto from './games/CarRunnerAuto';
import LaundrySort from './games/LaundrySort';

const GAMES = {
  food:     FlappyFood,
  beauty:   HaircutBeauty,
  interior: PaintInterior,
  auto:     CarRunnerAuto,
  laundry:  LaundrySort,
};

export default function EasterEggGame({ mode = 'food', onClose }) {
  const Game = GAMES[mode] || FlappyFood;
  return <Game onClose={onClose} />;
}
